import { useTeamsStore, useFilterStore } from '~/stores'

export default defineNuxtRouteMiddleware((to, from) => {
  const {
    $i18n: { t }
  } = useNuxtApp()

  const fromLocale = from.path.split('/').splice(1)[0]
  const toLocale = to.path.split('/').splice(1)[0]
  const teamsStore = useTeamsStore()
  const filterStore = useFilterStore()

  if (fromLocale !== toLocale) {
    teamsStore.$reset()
    filterStore.$reset()
  }

  if (to.query._storyblok_published || to.query._storyblok_draft) {
    return navigateTo(`/${toLocale}${formatSbPath(to.path, toLocale)}`)
  }

  // Redirect from old urls
  if (['/embed', '/jobs'].some((text) => to.path.includes(text))) {
    const path = `/${toLocale}/${t('vacancies.code')}`

    if (to.path !== path) {
      return navigateTo(path)
    }
  }

  if (['/about-us', '/meet-us'].some((text) => to.path.includes(text))) {
    const path = `/en/culture`

    if (to.path !== path) {
      return navigateTo(path)
    }
  }
})
